import {
  documentKindNames,
  isNumberlessBill,
  manifestNumberLabel,
} from "encamp-shared/src/waste/shippingDocumentLabels";
import { ShippingDocumentKind } from "generated-graphql/graphql";

/**
 * Toast shown after a successful manifest edit.
 *
 * Editing a manifest only changes source values synchronously; the manifest's
 * discrepancies are recomputed by a background process-manifests job that runs
 * after the edit commits. The copy sets that expectation so a reviewer doesn't
 * read the unchanged counts as "the edit didn't take".
 *
 * When the tracking number changes the backend creates a new manifest record;
 * surface its new number so the reviewer can follow the move.
 */
export function editManifestSuccessMessage(
  newManifest: { manifestTrackingNumber: string } | null | undefined,
  documentKind?: ShippingDocumentKind | null
): string {
  const { sentence } = documentKindNames(documentKind);
  const recalculating = "Discrepancies will update shortly as they recalculate in the background.";
  if (newManifest) {
    return `${sentence} successfully updated. ${newDocumentSentence(newManifest.manifestTrackingNumber, documentKind)} ${recalculating}`;
  }
  return `${sentence} successfully updated. ${recalculating}`;
}

/** "A new manifest has been created for …", leaving out a generated number. */
export function newDocumentSentence(
  manifestTrackingNumber: string,
  documentKind?: ShippingDocumentKind | null
): string {
  const { noun, numberNoun } = documentKindNames(documentKind);
  if (isNumberlessBill({ manifestTrackingNumber })) {
    return `A new ${noun} has been created with no printed number.`;
  }
  return `A new ${noun} has been created for ${numberNoun} ${manifestNumberLabel({ manifestTrackingNumber })}.`;
}
